module.exports = __webpack_public_path__ + "static/media/phone2youStart.36aa121b.png";